import React, { FC, useContext, useState } from "react";

import { RapComponentContext } from "../../Layout";
import { IRapAuthenticationService } from "../../services/Authentication";

interface ISecurityGroupProps {
    securityGroupId: string;
    renderOnUnAuthorized?: React.ReactNode;
}

export const SecurityGroup: FC<ISecurityGroupProps> = (props) => {
    const context = useContext(RapComponentContext);
    const [isUserAuthenticated, setIsUserAuthenticated] = useState(undefined);

    let authService = context.pageContext.getService<IRapAuthenticationService>("IRapAuthenticationService");
    authService.getToken().then(token => {
        const headers = new Headers();
        const bearer = `Bearer ${token}`;

        headers.append("Authorization", bearer);
        headers.append("Content-Type", "application/json");

        const options = {
            method: "POST",
            headers: headers,
            body: JSON.stringify({ groupIds:[props.securityGroupId] })
        };
        fetch("https://graph.microsoft.com/v1.0/me/checkMemberGroups", options).then(res => {
            res.json().then(json => {
                if(json.value.length > 0) {
                    setIsUserAuthenticated(true);
                }
                else {
                    setIsUserAuthenticated(false);
                }
            });
        }).catch(e => {
            console.error(e);
        });
    }).catch(e => {
        console.error("Error getting token: " + e);
    });


    return (
        <>
            {isUserAuthenticated && props.children}
            {isUserAuthenticated === false && props.renderOnUnAuthorized}
        </>
    );
}